// enable facets
var searchConfig = {
  facets: {}
};

// define search result layout
var resultTemplate = Hogan.compile([
  '<div class="st-result" data-id="{{id}}">',
    '<a href="{{url}}" class="product-tile st-search-result-link">',
      '<img src="{{{image}}}" class="st-result-image {{id}}" />',
      '<div class="st-result-title"><span style="font-weight: 500;">{{{title}}}</span><br>{{{vendor}}}</div>',
  '<div class="st-result-price serif">{{{price}}}</div>',
  '<div class="st-result-price-season serif" data-price="{{{price_season}}}"><strong>${{{price_season}}}</strong> <em>for Season Lease</em></div>',
    '</a>',
      '<div class="st-result-thumbs">',
        '<img class="thumb" src="{{{color0}}}" data-target-id="{{id}}">',
        '<img class="thumb" src="{{{color1}}}" data-target-id="{{id}}">',
        '<img class="thumb" src="{{{color2}}}" data-target-id="{{id}}">',
        '<img class="thumb" src="{{{color3}}}" data-target-id="{{id}}">',
      '</div>',
  '</div>'
].join('') );

// define data variables
var customRenderer = function(documentType, item) {
  
  if (item['tags'].indexOf('Wetsuit') !== -1) {
  
    var data = {
      id: item['id'],
      title: item['title'],
      vendor: item['vendor'],
      url: item['url'],
      image: item['image'],
      price: '<strong>$' + item['price_min'] + '</strong> <em>for 3 weeks use</em>',
      price_season: item['price_season'],
      color0: item['color_thumb_0'],
      color1: item['color_thumb_1'],
      color2: item['color_thumb_2'],
      color3: item['color_thumb_3'],
      from: false,
      duration: '3 weeks'
    };
      
  } else {
  
    var data = {
      id: item['id'],
      title: item['title'],
      vendor: item['vendor'],
      url: item['url'],
      image: item['image'],
      price: '<strong>$' + item['price_min'] / 4 + '</strong> <em>per day (4 days minimum)</em>',
      price_season: item['price_season'],
      color0: item['color_thumb_0'],
      color1: item['color_thumb_1'],
      color2: item['color_thumb_2'],
      color3: item['color_thumb_3'],
      from: true,
      duration: '4 days'
    };
    
  }
  
  return resultTemplate.render(data);
};


var $facetContainer = $('.st-dynamic-facets');
var reloadResults = function() { $(window).hashchange(); };

var bindControls = function(data) {

  var resultInfo = data['info'],
      facets = '',
      totalResultCount = 0,
      $resultContainer = this.getContext().resultContainer,
      spellingSuggestion = null;

  $.each(resultInfo, function(index, value) {
    totalResultCount += value['total_result_count'];
    if ( value['spelling_suggestion'] ) {
      spellingSuggestion = value['spelling_suggestion']['text'];
    }
  });
      
  $('.st-query').html(Swiftype.currentQuery); // added by matt williams

  if (totalResultCount === 0) {
    $resultContainer.html("<div id='st-no-results' class='st-no-results'>No results found.</div>");
  } else {
    $('.st-results-count').html(totalResultCount + ' results found'); // added by matt williams
  }

  if (spellingSuggestion !== null) {
    $resultContainer.append('<div class="st-spelling-suggestion">Did you mean <a href="#" data-hash="true" data-spelling-suggestion="' + spellingSuggestion + '">' + spellingSuggestion + '</a>?</div>');
  }

  $.each(resultInfo, function(documentType, typeInfo){
    $.each(typeInfo.facets, function(field, facetCounts) {
      facets += [
        '<div class="facet"><h3>', 
        field, 
        '</h3><div class="options">'
      ].join('')
      
      $.each(facetCounts, function(label, count) {
        var status = "",
            id = encodeURIComponent(label).toLowerCase();
        if (window.searchConfig.facets[field] && window.searchConfig.facets[field].indexOf(label) > -1) {
          status = 'checked="checked"'
        }
        facets += '<input type="checkbox"' + status + ' name="' + field + '" value="' + label + '" id="' + id + '"> <label for="' + id + '">' + label + ' (' + count + ')</label><br/>';
      });
      facets += '</div></div>'
    });
    $facetContainer.html(facets);
  });
};

var readSortField = function() {
  return { page: window.searchConfig.sort.field };
};

var readSortDirection = function() {
  return { page: window.searchConfig.sort.direction };
};

$('.sort').on('click', function(e){
  e.preventDefault();
  // Visually change the selected sorting order
  $('.sort').removeClass('active');
  $(this).addClass('active');
  // Update sorting settings
  window.searchConfig.sort.field = $(this).data('field');
  window.searchConfig.sort.direction = $(this).data('direction');
  reloadResults();
});

$facetContainer.on('click', 'input', function(e) {
  window.searchConfig.facets = {}; // Set the hash to empty
  $('.st-dynamic-facets input[type="checkbox"]').each(function(idx, obj) {
    var $checkbox = $(obj),
        facet = $checkbox.prop('name');
    if(!window.searchConfig.facets[facet]) {
      window.searchConfig.facets[facet] = [];
    }
    if($checkbox.prop('checked')) {
      window.searchConfig.facets[facet].push($checkbox.prop('value'));
    }
  })
  reloadResults();
});

$facetContainer.on('click', 'a.clear-selection', function(e) {
  e.preventDefault();
  var name = $(this).data('name');
  $('input[name=' + name + ']').prop('checked', false);
  window.searchConfig.facets[name] = [];
  reloadResults();
});

var readFilters = function() {
  return {
    page: {
      gender: window.searchConfig.facets['gender'],
      age: window.searchConfig.facets['age'],
      category: window.searchConfig.facets['category'],
      vendor: window.searchConfig.facets['vendor']
    }
  }
}

$('#st-search-input').swiftypeSearch({
  resultContainingElement: '#st-results-container',
  engineKey: 'rDba4taRty4vTHN1cR4C',
  renderFunction: customRenderer,
  facets: { page: ['gender', 'age', 'category', 'vendor'] },
  filters: readFilters,
  postRenderFunction: bindControls,
  perPage: 300
});

$('#st-search-input').swiftype({
  engineKey: 'rDba4taRty4vTHN1cR4C'
});